/** 轮询演示信息，在 socket 房间人数上限时降级使用 */

import { ILiveInfo } from '../LiveConst';
import axios from 'axios';

export type Info = Pick<ILiveInfo, 'allow_flip' | 'page' | 'fragment' | 'iaFragmentInfo' | 'state' | 'info'>;

export const getRoomInfo = async (roomId: string): Promise<Info | null> => {
    const url = `//${window.location.hostname}/show-api/getroominfo?roomId=${roomId}`;
    try {
        const { data }  = await axios.get(url);
        if (data?.retcode !== 0) return null;

        return data.result as Info;
    } catch (error) {
        return null;
    }
}

export const startPollingRoomInfo = (roomId: string, callback: (info: Info) => void, opts = { interval: 5000 }) => {
    let lastSeq = 0;
    let lastSuccessSeq = 0;
    const timer = setInterval(() => {
        const seq = lastSeq + 1;
        lastSeq = seq;
        getRoomInfo(roomId).then(info => {
            if (!info) return;
            if (seq <= lastSuccessSeq) return;

            callback(info);
            lastSuccessSeq = seq;
        });
    }, opts.interval);

    return () => clearInterval(timer);
}